<template>
  <popup
    buttonText="Add Site Workflow"
    heading="Add Site Workflow"
    buttonIcon="fa fa-plus"
    buttonSize="mini"
    buttonStyle="warning"
    round
    ref="siteWorkflowModal"
    :show-cancel="false"
    :show-save="false">

    <el-form label-width="150px">

      <select-site v-if="!siteId" v-model="selectedSite" />
      <el-form-item v-else label="Selected Site:">
         <b>{{siteName ? siteName : ('Site ID: ' + siteId)}}</b>
      </el-form-item>

      <select-organisation v-model="selectedOrgId" />

      <select-workflow v-model="wf" @change="listen" />

      <el-form-item >
        <el-button type="success" @click="createNew" class="pull-right">Add</el-button>
      </el-form-item>

    </el-form>
  </popup>
</template>

<script>
import Vue from 'vue'
import VueEvents from 'vue-events'
import axios from '@/lib/axiosClient'

Vue.use(VueEvents)

import WorkflowMixins from '@/mixins/WorkflowMixins'
import SelectWorkflow from '@/components/atoms/selects/SelectWorkflow'
import SelectOrganisation from '@/components/atoms/selects/SelectOrganisation'

export default {
  mixins: [WorkflowMixins],

  components: {
    SelectOrganisation,
    SelectWorkflow
  },

  props: {

    sharer: {
      type: Number,
      default: null
    },

    rowIndex: {
      type: Number
    },

    siteId: {
      type: Number,
      default: null
    },

    siteName: {
      type: String,
      default: null
    }

  },


  methods: {
    createNew () {
      var params = {
        workflowId: this.wf,
        siteId: this.siteId ? this.siteId : this.selectedSite,
        orgId: this.selectedOrgId
      }

      var apiURL = this.getEndpoint('workflow/sites/new')
      axios.post(apiURL, params).then(res => {

        this.$message({
          type: res.data.type ? res.data.type : 'info',
          message: res.data.message
        })

        this.selectedSite = null
        this.wf = null
        this.selectedOrgId = null

        this.$events.fire(this.SITE_WORKFLOW_TABLE_REF)
        this.$refs.siteWorkflowModal.closeModal()
      })
    },

    listen (wf) {
      this.wf = wf
    }
  },

  data () {
    return {
      searchText: '',
      selectedSite: null,
      wf: null,
      selectedOrgId: null
    }
  }


}
</script>



// WEBPACK FOOTER //
// AddSiteWorkflow.vue?7cd989cb